
// Convert Firestore Timestamp (or anything else with `toDate` method) to JS Date.
const normalizeDate = (tsOrDate): Date => tsOrDate?.toDate?.() || tsOrDate;

export default normalizeDate;
